import React,{useEffect} from 'react'

import {
    Backtotop,
    Floatinmenu,
    Underline,
  } from "../../widgets";
  
  import {
    cse_dept_menu,
  } from "../../constants/cse_dept";
  
  import {Listformat, Timeline} from '../../components'
  
  import { RadialMenu } from "../../components";

  import {FaComputer} from 'react-icons/fa6'

import {cse_prog_time} from '../../constants/cse_dept'




const Cse_prog_org = () => {
  useEffect(() => {
    document.title = 'ACCET-CSE | Programs';
  }, []);
    return (
        <div className="csedept">
          <div className="csebg">
            <div className="cseheading">
            Department of Computer Science and Engineering
            </div>
            <div className="cse_sub_heading">Programs</div>
          </div>
          <section className="csedark">
            <div className="dept_float_menu">
              <Floatinmenu logo={FaComputer} head="Menu" links={cse_dept_menu} />
            </div>
            <RadialMenu menu_links={cse_dept_menu} />
            <div className="cse_peo_area">
              <div className="cse_peo">
                <Underline heading="Programs Organized" />
                {cse_prog_time.map((item) => (
                  <Timeline
                    key={item.id}
                    head={item.head}
                    house={item.house}
                    content={item.content}
                  />
                ))}
              </div>
    
              
            </div>
          </section>
    
          <Backtotop />
        </div>
      );
}

export default Cse_prog_org